import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemTouchAction extends Cloneable {
    static DISABLED = new ItemTouchAction(0, "DISABLED");
    static INFO_DETAILS = new ItemTouchAction(1, "INFO_DETAILS");

    static _values = [
        this.DISABLED,
        this.INFO_DETAILS,
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemTouchAction.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemTouchAction) {
            return ItemTouchAction._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DEFAULT") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemTouchAction) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemTouchAction());
        } else if (target instanceof ItemTouchAction) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemTouchAction, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});